import { sendGet } from "api/restUtil";
import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";


/**
 * 공통코드로 Select 표시
 * @param {boolean} valNm value를 이름으로 할지 여부. true이면 option의 value, label이 모두 공통코드 명으로 설정
 * @returns 
 */
export default function CommonCodeSelect({ item, onChange, onClick, value, readOnly, grpCd, except, defaultLabel = "선택하세요", valNm = false, width, onKeyDown, addDefault = true, ref }) {

	const [options, setOptions] = useState([]);
	const [defaultValue, setDefaultValue] = useState("");
	useEffect(() => {
		sendGet("/api/cmn-cd/" + grpCd )
		.then(result => {
			if(result.respCode !== "SUCCESS") return;
			let resultData = result.data;
			// resultData = resultData.filter(d => d.desc !== "EXCLUDE_FROM_LIST");
			if(except)
				resultData = resultData.filter(d => !except.includes(d.desc));
			if(addDefault) {
				resultData.unshift({cd: "", cdNm: defaultLabel});
			}
			const selOptions = resultData.map((item) => {
				if(valNm && item.cdNm!=="") {
					return {label: item.cdNm, value: item.cdNm };
				} else {
					return {label: item.cdNm, value: item.cd };
				}
			})
			setOptions(selOptions);
			if(selOptions && selOptions.length > 0) {
				setDefaultValue(selOptions[0].value);
			}

			if(!addDefault && selOptions && selOptions.length > 0) {
				// addDefault가 아니면 강제로 상위 컴포넌트에 값 전달.
				const evt = {target: {name : item.col ?? "", value : selOptions[0].value}};
				onChange(evt);
			}
		});
	},[]);
    // const defaultValue = item.option && item.option.length > 0 ? item.option[0].value : "";

    return (
        <>
			<div onKeyDown={onKeyDown && (e => onKeyDown(e))}>
				<select
					id={uuidv4()}
					className="basic-input"
					name={item.col || ""}
					onChange={onChange && ((e) => onChange(e))}
					onClick={onClick && ((e) => onClick(e))}
					value={value || defaultValue}
					placeholder={item.placeholder || ""}
					readOnly={readOnly || false}
					disabled={item.disabled || false}
					style={{width : width}}
					ref={ref}
				>
					{options &&
						options.map((op, index) => (
							<option key={index} value={op.value}>
								{op.label}
							</option>
					))}
				</select>
			</div>
        </>
    );
}
